<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid

            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col cols="12">
                        <v-expand-transition>
                            <v-card 
                                width="400"
                                v-show="expand"
                                class="elevation-12 mx-auto pa-4"
                            >                            
                                <v-row
                                    justify="center"
                                >
                                    <v-img
                                        src="../../assets/logo.png"
                                        max-width="120"
                                        contain
                                        class="d-flex"
                                    ></v-img>
                                </v-row>
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <div 
                                            class="pa-4"
                                            v-if="getloginErrors"
                                        >
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                
                                                class="red--text"
                                            >
                                                {{ getloginErrors }}
                                            </v-alert>    
                                        </div>                                       
                                        
                                        <div class="text-center font-weight-light primary--text">Welcome to</div>
                                        <div 
                                            class="text-h4 text-sm-h5 font-weight-black text-center primary--text"
                                            v-html="schoolName"
                                        ></div>        
                                        <v-card-text>
                                            <div class="primary--text text-h5 text-center">Student Registration Portal</div>                                            
                                        </v-card-text>

                                        <v-form 
                                            class="pa-5"
                                            @submit.prevent
                                        >
                                            <v-text-field
                                                label="SEA ID / Birth Certificate Pin"                                                
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.sea_no"
                                                clearable
                                                autofocus
                                                v-on:keyup="keyPressId"                                                  
                                            >
                                                <v-icon
                                                    slot="prepend"
                                                    color="primary"
                                                >
                                                    mdi-account
                                                </v-icon>
                                            </v-text-field> 

                                            <v-menu
                                                ref="menuDateOfBirth"
                                                v-model="menuDateOfBirth"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                                
                                            >
                                                <template v-slot:activator="{ on, attrs}">
                                                    <v-text-field
                                                        v-model="dateOfBirthFormatted"
                                                        label="Date of Birth"
                                                        hint="YYYY/MM/DD"
                                                        persistent-hint
                                                        prepend-icon="mdi-calendar"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @blur="dateOfBirth = parseDate(dateOfBirthFormatted)"
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    ref="picker"
                                                    v-model="formData.date_of_birth"
                                                    :active-picker.sync="activePicker"
                                                    :max="new Date().toISOString().substr(0, 10)"
                                                    min="1950-01-01"
                                                    @input="menuDateOfBirth = false"
                                                ></v-date-picker>
                                            </v-menu>
                                                                        
                                    
                                            <div 
                                                class="text-right mt-6"
                                            >                                                
                                                <v-btn 
                                                    color="primary" 
                                                    @click="submit" 
                                                    dark
                                                    block
                                                >LOGIN</v-btn>
                                            </div>
                                             
                                        </v-form>        
                                    </v-col>
                                </v-row>
                               
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
                <query-id/>
            </v-container>            
        </v-main>        
    </v-app>
</template>

<script>
import QueryId from '../QueryId'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        QueryId,
    },
    data(){
        return {            
            show: false,
            userpassword: '',
            formData: {
                date_of_birth: '',
                sea_no: '',
            },
            password: true,
            expand: true,
            menuDateOfBirth: false,
            dateOfBirth: null,
            activePicker: null,
            rules: {
                required: value => !!value || 'Required.',
            },
        }
    },

    props: {
        source: String,
    },

    watch: {
         menuDateOfBirth (val) {
            if(val){
                this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            }
        },

    },

    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',
            primaryColor: 'form/getPrimaryColor',
            colorDarken: 'form/getColorDarken',
            getloginErrors: 'auth/getLoginErrors',
            authenticated: 'auth/getAuthenticated',
            admin: 'auth/getAdmin',
            validStudentID: 'auth/getStudentIDValidation',
            step: 'auth/getStep',
            passwordHint: 'auth/getPasswordHint',
            passwordPlaceholder: 'auth/getPasswordPlaceholder',                       
        }),

        dateOfBirthFormatted () {
            if(!this.formData.date_of_birth) return null;
            const [year, month, day] = this.formData.date_of_birth.split('-');
            return `${year}/${month}/${day}`;
        }
        
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            changePassword: 'auth/changePassword',            
            getUser: 'auth/getUser',            
        }),

        ...mapMutations({
            openDialog: 'auth/setDialog',
            setNewPassword: 'auth/setNewPassword',
            setUserID: 'auth/setUserID',
            setStep: 'auth/setStep',
            setOverlay: 'auth/setOverlay',
            setAuthenticated: 'auth/setAuthenticated',
            setUser: 'auth/setUser',            
        }),

        keyPressPassword (e) {            
            if(e.keyCode === 13){
                this.submit();
            }
        },

        keyPressId (e) {
            if(e.keyCode === 13){
                this.$refs.password.focus();
            }
        },       

        async submit () {                     
            console.log('Authenticating..');
            await this.signIn(this.formData);
            console.log(`Authenticated: ${this.authenticated}`)
            this.setUser({
                student_id : this.formData.student_id
            })
            if(this.authenticated){                
                this.$router.replace('/registration/student-data');
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }
            this.setOverlay(false);                     
        },

        parseDate (date) {
            if(!date) return null;
            const [day, month, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },

    }
}
</script>

<style scoped>
    .container-background{
        background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    
</style>

